<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2023-05-23 10:41:16
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-06 15:54:03
-->
<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="550px"
    :before-close="handleClose"
  >
     <coententTable
              :columns="columns"
              :dataSource="dataSource"
              :loading="loading"
              :customSlot="customSlot"
              :y="500"
            >
            <template v-slot:cishu="scopeVal">
                 <div v-if="scopeVal.scope.status == 0">{{scopeVal.scope.num}}</div>
                  <div style="color:#E6A23C" v-if="scopeVal.scope.status == 1">{{scopeVal.scope.num}}</div>
                <div style="color:rgba(245, 108, 108, 1)" v-if="scopeVal.scope.status == 2">{{scopeVal.scope.num}}</div>
            </template>
            <template v-slot:lastUpdateTime="scopeVal">
                 <div v-if="scopeVal.scope.status == 0">{{scopeVal.scope.lastUpdateTime}}</div>
                  <div style="color:#E6A23C" v-if="scopeVal.scope.status == 1">{{scopeVal.scope.lastUpdateTime}}</div>
                <div style="color:rgba(245, 108, 108, 1)" v-if="scopeVal.scope.status == 2">{{scopeVal.scope.lastUpdateTime}}</div>
            </template>
            <template v-slot:columnName="scopeVal">
                <div class="style-box" v-if="scopeVal.scope.status == 0">{{scopeVal.scope.columnName}}</div>
                <div class="style-box" style="color:#E6A23C" v-if="scopeVal.scope.status == 1">{{scopeVal.scope.columnName}}</div>
                <div class="style-box" style="color:rgba(245, 108, 108, 1)" v-if="scopeVal.scope.status == 2">{{scopeVal.scope.columnName}}</div>
            </template>
            <template v-slot:status="scopeVal">
                <div v-if="scopeVal.scope.status == 0">合格</div>
                <div style="color:#E6A23C" v-if="scopeVal.scope.status == 1">警告</div>
                <div style="color:rgba(245, 108, 108, 1)"v-if="scopeVal.scope.status == 2">不合格</div>
            </template>
            </coententTable>
  </el-dialog>
</template>
<script >
import coententTable from "@/components/coentent_table.vue";
import {indexColumnInfoList} from '../index';
export default {
  components:{
    coententTable
  },
  data() {
    return {
       columns: [
        {
          title: "序号",
          dataIndex: "num",
          ellipsis: true,
          scopedSlots: { customRender: "cishu" },
        },
        {
          title: "栏目名称",
          dataIndex: "columnName",
          ellipsis: true,
          width:120,
          scopedSlots: { customRender: "columnName" },
        },
        {
          title: "最后一次更新",
          dataIndex: "lastUpdateTime",
          ellipsis: true,
           width:150,
          scopedSlots: { customRender: "lastUpdateTime" },
        },
        {
          title: "监测结果",
          dataIndex: "status",
           width:120,
          scopedSlots: { customRender: "status" },
          ellipsis: true,
        }
      ],
      customSlot: [
        {
          name: "status",
          customRender: "status",
        },
        {
          name: "lastUpdateTime",
          customRender: "lastUpdateTime",
        },
        {
          name: "columnName",
          customRender: "columnName",
        },
         {
          name: "cishu",
          customRender: "cishu",
        }
      ],
       dataSource: [],
      loading: false,
      dialogTitle:'',
    };
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    itemData:{}
  },
  mounted() {
    this.getList()
    this.dialogTitle = `首页不更新监测清单（${this.itemData.time}）`
  },
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },
    getList(){
      this.loading = true;
      indexColumnInfoList({
        siteId:sessionStorage.getItem('siteId'),
        time: this.itemData.time,
      }).then((res)=>{
          if(res.code == 0){
              this.dataSource = res.data;
              for (let index = 0; index <  this.dataSource.length; index++) {
                const element =  this.dataSource[index];
                element.num = index + 1;
              }
          }
          this.loading = false;
      })
    }
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog{
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(187, 187, 187, 1);
}
/deep/ .el-dialog__title {
  color: rgba(48, 49, 51, 1);
  font-size: 18px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-bold;
  font-weight: 600;
}
/deep/ .el-icon-close {
  font-weight: 600;
  color: rgba(48, 49, 51, 1);
  font-size: 20px;
}
/deep/ .table{
  margin: 0px;
}
/deep/ .el-dialog__body{
  padding-top: 10px;
}
.style-box{
  overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow:ellipsis;
}

</style>
